<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-toolbar flat>
          <v-select
            label="Status"
            dense
            outlined
            item-text="text"
            item-value="value"
            :items="[
              { text: 'Active', value: 'ACTIVE' },
              { text: 'Deactive', value: 'DEACTIVE' },
            ]"
            style="max-width: 170px"
            v-model="Statuslist"
            @change="getlistKiosk()"
          ></v-select>
          <v-spacer />
          <v-btn
            small
            color="primary"
            class="white--text mt-3"
            @click="addKiosk()"
          >
            <v-icon dark>mdi-plus</v-icon></v-btn
          >
        </v-toolbar>
        <v-data-table
          :height="height"
          :fixed-header="fixed"
          :headers="headers"
          :items="DataItems"
          :loading="tableLoading"
          :items-per-page="100"
          dense
          class="overflow-y-auto"
        >
          <template v-slot:[`item.kiosk_type`]="{ item }">
            <span v-if="item.kiosk_type == 'BOTH'">Employee and Visitor</span>
            <span v-else-if="item.kiosk_type == 'EMPLOYEE'">Employee</span>
            <span v-else>Visitor</span>
          </template>

          <template v-slot:[`item.Actions`]="{ item }">
            <v-icon
              small
              @click.stop="edit_kiosk(item)"
              color="primary"
              class="mr-2"
              v-if="Statuslist == 'ACTIVE'"
            >
              mdi-pencil</v-icon
            >
            <v-icon
              small
              @click.stop="delete_kiosk(item)"
              color="red"
              class="mr-2"
            >
              mdi-account-reactivate-outline</v-icon
            >
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <div v-if="componentCheck == 1">
      <CreateKisok
        :kisokCreation="kisokCreation"
        @clicked="kisokCreation = false"
        v-on:errorMsg="error_info"
        v-on:successMsg="success_info"
      />
    </div>
    <div v-if="componentCheck == 2">
      <EditKisok
        :kisokEdition="kisokEdition"
        @clicked="kisokEdition = false"
        v-on:errorMsg="error_info"
        v-on:successMsg="success_info"
        :kisokItems="kisokItems"
      />
    </div>
    <div v-if="componentCheck == 3">
      <ActivateKiosk
        :kisokdeletion="kisokdeletion"
        @clicked="kisokdeletion = false"
        v-on:errorMsg="error_info"
        v-on:successMsg="success_info"
        :kisokItems="kisokItems"
      />
    </div>
    <SnackBar :SnackBarComponent="SnackBarComponent" />
  </div>
</template>

<script>
import ActivateKiosk from "@/components/Dialogs/ActivateKiosk.vue";
import EditKisok from "@/components/Dialogs/EditKisok.vue";
import { getKioskForOrg } from "@/graphql/queries.js";
import { API, graphqlOperation } from "aws-amplify";
import CreateKisok from "@/components/Dialogs/CreateKisok.vue";
import SnackBar from "@/components/SnackBar.vue";
export default {
  components: {
    SnackBar,
    CreateKisok,
    EditKisok,
    ActivateKiosk,
  },
  data() {
    return {
      SnackBarComponent: {},
      kisokItems: {},
      Statuslist: "ACTIVE",
      height: 0,
      componentCheck: 0,
      fixed: true,
      tableLoading: false,
      kisokCreation: false,
      kisokEdition: false,
      kisokdeletion: false,
      headers: [
        {
          text: "Name",
          value: "kiosk_name",
          sortable: false,
        },
        {
          text: "kiosk Type",
          value: "kiosk_type",
          sortable: false,
        },

        {
          text: "Kiosk Unique ID",
          value: "kiosk_unique_id",
          sortable: false,
        },
        {
          text: "Location Name",
          value: "location_name",
          sortable: false,
        },

        {
          text: "Action",
          value: "Actions",
          sortable: false,
        },
      ],
      DataItems: [],
    };
  },
  async mounted() {
    this.height = window.innerHeight - 240;
    await this.getlistKiosk();
  },
  methods: {
    edit_kiosk(item) {
      this.componentCheck = 2;
      this.kisokEdition = true;
      this.kisokItems = item;
    },
    delete_kiosk(item) {
      this.componentCheck = 3;
      this.kisokdeletion = true;
      this.kisokItems = item;
    },
    async getlistKiosk() {
      this.DataItems = [];
      this.tableLoading = true;
      try {
        let result = await API.graphql(
          graphqlOperation(getKioskForOrg, {
            input: {
              organisation_id:
                this.$store.getters.get_org_details[0].organisation_id,
              kiosk_status: this.Statuslist,
            },
          })
        );

        var response = JSON.parse(result.data.getKioskForOrg);
        this.tableLoading = false;
        if (response.Status == "SUCCESS") {
          console.log(response.data, "response");
          this.DataItems = response.data;
          this.tableLoading = false;
        } else {
          this.DataItems = [];

          this.tableLoading = false;
        }
      } catch (error) {
        console.log(error);
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          Top: true,
          SnackbarText: error.errors[0].message,
        };

        this.tableLoading = false;
      }
    },
    addKiosk() {
      this.componentCheck = 1;
      this.kisokCreation = true;
    },
    success_info(val) {
      this.SnackBarComponent = {
        SnackbarVmodel: true,
        SnackbarColor: "green",
        SnackbarText: val,
        timeout: 5000,
        Top: true,
      };
      this.kisokCreation = false;
      this.kisokEdition = false;
      this.kisokdeletion = false;
      this.getlistKiosk();
    },
    error_info(val) {
      this.SnackBarComponent = {
        SnackbarVmodel: true,
        SnackbarColor: "red",
        SnackbarText: val,
        timeout: 5000,
        Top: true,
      };
    },
  },
};
</script>

<style>
</style>